import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DeleteIconComponent } from './delete-icon/delete-icon.component';

@NgModule({
  declarations: [DeleteIconComponent],
  imports: [CommonModule],
  exports: [DeleteIconComponent],
})
export class IconsModule {}
